export default __webpack_public_path__ + "static/media/background.82b5a5df.png";